// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.errorWapper {
  padding: 50px;
  min-height: calc(100vh - 230px);
  background-image: url('bg1.jpg');
}`, "",{"version":3,"sources":["webpack://./src/app/core/modules/error/error.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,+BAAA;EACA,gCAAA;AACJ","sourcesContent":[".errorWapper {\r\n    padding: 50px;\r\n    min-height: calc(100vh - 230px);\r\n    background-image: url(../../../../assets/media/error/bg1.jpg);\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
